import React from 'react';

import {DialogProps, Grid, Stack} from '@mui/material';

import {Types} from '@wheeebo/polaris-api';
import {GoogleMapProvider, MissionMap} from '@wheeebo/polaris-ui';

import {config} from '@components/Constants';
import MissionProfileCard from './mission/MissionProfileCard';
import DialogBase from './DialogBase';

interface Props extends DialogProps {
  missionId: Types.UUID;
  onGroupSelected: (groupId: Types.UUID) => void;
  onClose: () => void;
}

const MissionDialog = ({missionId, onGroupSelected, onClose, ...props}: Props): JSX.Element => {
  return (
    <DialogBase title="Mission" onClose={onClose} {...props}>
      <GoogleMapProvider>
        <MissionMap apiKey={config.GOOGLE_MAP_API_KEY || ''} missionId={missionId} hideAllUIs />
      </GoogleMapProvider>
      <Grid container spacing={1}>
        <Grid item xs={12} sm={5}>
          <Stack gap={1}>
            <MissionProfileCard missionId={missionId} onGroupSelected={onGroupSelected} />
          </Stack>
        </Grid>
        <Grid item xs={12} sm={7}>
          <Stack gap={1}></Stack>
        </Grid>
      </Grid>
    </DialogBase>
  );
};

export default React.memo(MissionDialog);
